import { useEffect, useRef } from 'react';
import { matchRoutes, Navigate, useLocation } from 'react-router-dom';
import { identifyAnalyticsUser, trackPageView } from '../lib/analytics';
import { hasPageAccess } from '../lib/pageAccess';

export default function AnalyticsTracker({ routes, user, loading }) {
  const location = useLocation();
  const lastPage = useRef(null);
  useEffect(() => {
    if (!loading) identifyAnalyticsUser(user?.id);
  }, [loading, user?.id]);
  useEffect(() => {
    if (loading) return;
    const route = matchRoutes(routes, location)?.at(-1)?.route;
    if (!route || route.path === '*' || route.element?.type === Navigate) return;
    if ((route.type === 'private' || route.type === 'protected') && !user?.email) return;
    if (route.type === 'public' && user?.email) return;
    if (route.ownerOnly && user?.role !== 'owner') return;
    if (route.pageKey && !hasPageAccess(user, route.pageKey)) return;
    // Ignore query/hash updates and StrictMode effect replay; retain real revisits.
    if (lastPage.current === location.pathname) return;
    lastPage.current = location.pathname;
    trackPageView(route.path);
  }, [location, loading, routes, user]);
  return null;
}
